// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ActivityResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type ActivityApiResponse = {
	id: string;
	name: string;
	color: string;
	followAddress: boolean;
	address: string | null;
	followContact: boolean;
	contactEmail: string | null;
	contactName: string | null;
	contactPhone: string | null;
	followLogo: boolean;
	logo: string | null;
	parentId: string;
	archivedAt: string | null;
};

export type Activity = {
	id: string;
	name: string;
	color: string;
	followAddress: boolean;
	address: string | null;
	followContact: boolean;
	contactEmail: string | null;
	contactName: string | null;
	contactPhone: string | null;
	followLogo: boolean;
	logo: string | null;
	parentId: string;
	archivedAt: DateTime | null;
};

export function hydrateActivity(data: ActivityApiResponse): Activity {
	return {
		...data,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}